/* eslint-disable */
import {gsap} from "gsap";

const titleDecoLines = {

  init: function () {
    this.decoLines1Width();

    window.addEventListener('resize', () => {
      this.resetDecoLines1();
      this.decoLines1Width();
    });
  },

  decoLines1Width: function () {
    const titles = document.querySelectorAll('[data-title-dl1-js]');
    if (!titles.length) return;

    titles.forEach((title) => {
      const computedStyles = window.getComputedStyle(title);
      const transformMatrix = computedStyles.transform;
      let matrixComponents;
      let horizontalShift;
      if(transformMatrix && transformMatrix !== 'none') {
        matrixComponents = transformMatrix.match(/matrix\(([^)]+)\)/)[1].split(', ');
        horizontalShift = parseFloat(matrixComponents[4]);
      } else {
        horizontalShift = 0;
      }
      const words = title.querySelectorAll('span');
      if (words.length === 0) return;

      const titleCoordinates = title.getBoundingClientRect();
      const decoEl = title.querySelector('[data-dl1-js]');
      const titleDecoPosition = title.getAttribute('data-dl1-position-js');
      const titleDecoEdge = title.closest('[data-dl1-edge-js]');
      let decoWidth;
      let decoPositionRight;
      let decoPositionLeft;
      let animationTransformValue =  (horizontalShift !== 0) ? 100 : 0;

      if (titleDecoPosition === 'left') {
        const lastWord = words[words.length - 1];
        const lastWordCoordinates = lastWord.getBoundingClientRect();

        if(titleDecoEdge) {
          const titleDecoEdgeCoordinates = titleDecoEdge.getBoundingClientRect();
          decoWidth = lastWordCoordinates.right - titleDecoEdgeCoordinates.left + animationTransformValue;
          decoPositionRight =  titleCoordinates.right - lastWordCoordinates.right;
        } else {
          decoWidth = lastWordCoordinates.right + animationTransformValue;
          decoPositionRight =  titleCoordinates.right - lastWordCoordinates.right;
        }

        decoEl.style.width = `${decoWidth}px`;
        decoEl.style.right = `${decoPositionRight}px`;

      } else if (titleDecoPosition === 'right') {
        const firstWord = words[0];
        const firstWordCoordinates = firstWord.getBoundingClientRect();
        decoPositionLeft =  0;

        if(titleDecoEdge) {
          const titleDecoEdgeCoordinates = titleDecoEdge.getBoundingClientRect();
          decoWidth = titleDecoEdgeCoordinates.right - firstWordCoordinates.left + animationTransformValue;
        } else {
          decoWidth = (window.innerWidth - firstWordCoordinates.left) + animationTransformValue;
        }

        decoEl.style.width = `${decoWidth}px`;
        decoEl.style.left = `${decoPositionLeft}px`;
      }
    });
  },

  resetDecoLines1: function () {
    const decoLines = document.querySelectorAll('.deco-line-1'); // Added missing class selector
    decoLines.forEach((el) => {
      el.style = '';
    });
  },
}

export default titleDecoLines;
